export const estates = [
  {
    name: "Mines Mass City",
    address: "Plot 634 Jibi District, Kubwa, Abuja",
  },
  {
    name: "Venture Scape Estate (Mines Apartment)",
    address: "Plot 44 Cadastral Zone D06, Karasana West, Abuja",
  },
  {
    name: "Mines Apartment",
    address: "Plot 7265 Cadastral Zone E25, Lugbe North, Abuja",
  },
  {
    name: "Mines Mass City",
    address: "Plot 43 Cadastral Zone D06, Karasana West, Abuja",
  },
  {
    name: "Mines Apartment",
    address: "Plot 3 Cadastral Zone D04, Life Camp Phase 1, Abuja",
  },
  {
    name: "Mines Apartment",
    address: "Plot 4 Cadastral Zone D04, Life Camp Phase 2, Abuja",
  },
  {
    name: "Mines Apartment",
    address: "Plot 605 Gwarinpa II, C03 Abuja",
  },
  {
    name: "Mines Apartment",
    address:
      "Plot 42726, Cadastral Zone C05, Karashi (Development Area), Abuja",
  },
  {
    name: "Mines Apartment",
    address: "Pyakassa, Lugbe, Abuja",
  },
  {
    name: "Mines Estate",
    address: "Plot CRD/CD78 Cadastral Zone 07-07, Lugbe",
  },
];
